"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _layout = require("../layout");

var _utils = require("../utils");

var _responsive = require("../responsive");

var _propTypes = require("../prop-types");

var _RowWithShadow = _interopRequireWildcard(require("../helpers/RowWithShadow"));

var _context = require("../context");

var _constants = require("./constants");

var _ModalTitle = _interopRequireDefault(require("./ModalTitle"));

var _core = require("@emotion/core");

var ModalContentWithoutDocs = function ModalContentWithoutDocs(_ref) {
  var children = _ref.children,
      titleText = _ref.titleText,
      buttons = _ref.buttons,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? _constants.ModalContentDefaultProps.maxWidth : _ref$maxWidth,
      dataTestId = _ref.dataTestId;
  var contentRef = (0, _react.useRef)(null);
  var footerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      footerHasShadow = _useState2[0],
      setFooterHasShadow = _useState2[1];

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var viewport = (0, _responsive.useBreakpoints)();
  var isSmallScreen = viewport.matches.s;

  var handleScroll = function handleScroll() {
    if (!contentRef.current || !footerRef.current) {
      return;
    }

    var _contentRef$current$g = contentRef.current.getBoundingClientRect(),
        contentBottom = _contentRef$current$g.bottom;

    var _footerRef$current$ge = footerRef.current.getBoundingClientRect(),
        footerTop = _footerRef$current$ge.top;

    setFooterHasShadow(contentBottom > footerTop);
  }; // Call handleScroll() once on mount to add the shadow if necessary


  (0, _react.useEffect)(function () {
    handleScroll();
  }, []);
  var forwardedMaxWidth = maxWidth === null ? undefined : maxWidth;
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilModalContent',
    dataTestId: dataTestId
  });
  var padding = isSmallScreen ? _constants.PADDING_SMALL_VIEWPORT : _constants.PADDING_LARGE_VIEWPORT;
  var screenEdgeGap = selectors.space(_constants.SCREEN_EDGE_GAP);
  var maxHeight = "calc(100vh - ".concat((0, _utils.px)(screenEdgeGap * 2), ")");
  var hasButtons = !!buttons && !!buttons.length;
  return (0, _core.jsx)(_layout.View, (0, _extends2.default)({}, dataTestProps, {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "neutral0",
    maxWidth: isSmallScreen ? undefined : forwardedMaxWidth,
    maxHeight: maxHeight
  }), (0, _core.jsx)(_layout.Col, {
    overflow: "auto",
    gridGap: _constants.TITLE_SPACING,
    padding: padding,
    flex: 1,
    "data-test-component": "StencilModalBody",
    onScroll: handleScroll
  }, titleText && (0, _core.jsx)(_ModalTitle.default, {
    id: _constants.MODAL_TITLE_ID
  }, titleText), (0, _core.jsx)("div", {
    ref: contentRef
  }, children)), hasButtons && (0, _core.jsx)("div", {
    ref: footerRef
  }, (0, _core.jsx)(_RowWithShadow.default, {
    hasShadow: footerHasShadow,
    shadowPosition: _RowWithShadow.ShadowPosition.Top,
    display: "flex",
    gridGap: _constants.FOOTER_SPACING,
    alignItems: "center",
    justifyContent: "flex-end",
    padding: [_constants.FOOTER_PADDING, padding],
    "data-test-component": "StencilModalFooter"
  }, buttons)));
};

var ModalContent = (0, _stencilReactDesc.describe)(ModalContentWithoutDocs).description('Panel designed to be used as a dialog-style modal.');
ModalContent.propTypes = {
  children: _stencilReactDesc.PropTypes.node.isRequired.description('Content to display in the body of the modal, below the title.'),
  titleText: _stencilReactDesc.PropTypes.string.isRequired.description('Text to display as the title of the modal.'),
  buttons: _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.node).description('Array of buttons to be displayed at the bottom of the modal.'),
  maxWidth: (0, _propTypes.cssValue)().description("Sets the CSS 'max-width' property for the modal."),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
};
ModalContent.displayName = 'ModalContent';
ModalContent.defaultProps = (0, _objectSpread2.default)({}, _constants.ModalContentDefaultProps);
var _default = ModalContent;
exports.default = _default;